import { defineFilters } from '@/components/kit/filters'

/**
 * Page and limit only. The endpoint takes nothing else, so there is nothing to
 * filter on — see the note on the page about what that costs.
 */
export const promoFilters = defineFilters({}, { defaultLimit: 20 })

export type PromoSearch = ReturnType<typeof promoFilters.parse>
